import { ConfigProvider, DatePicker } from "antd"
import itIT from "antd/lib/locale/it_IT"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled, { css } from "styled-components"

//------------------------------------------------------------------------------

function _AppDatePicker(props) {
    const { className, value, error, label, onBlur } = props

    const [focused, setIsFocused] = useState("")

    // -------------------------------------

    function onChange(event) {
        const { onChange } = props
        onChange(event)
    }

    function handleBlur() {
        setIsFocused(false)
        onBlur()
    }

    function handleFocus() {
        setIsFocused(true)
    }

    function getStateClass() {
        let cssClass = ""
        if (focused) {
            cssClass = "focused"
        } else {
            cssClass = value ? "valid" : ""
        }

        return cssClass
    }

    function disabledDate(current) {
        return current && current < moment().endOf("yesterday")
    }

    return (
        <div
            className={`${className} ${getStateClass()} app-input ${
                error ? "invalid" : ""
            }`}
        >
            <label className="input-label">{label}</label>
            <ConfigProvider locale={itIT}>
                <DatePicker
                    className="tm4-input"
                    onChange={onChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    suffixIcon={false}
                    format="DD/MM/YYYY"
                    disabledDate={disabledDate}
                    value={value}
                />
            </ConfigProvider>
            {error && <small className="error-msg">{error}</small>}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_AppDatePicker.propTypes = {
    className: PropTypes.string.isRequired,
    label: PropTypes.string,
    hiddenText: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.any,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
}

_AppDatePicker.defaultProps = {
    onChange: () => {},
    onBlur: () => {},
    validationMessage: null,
    disabled: false,
}

// ----------------------------------------------------------------------------

const AppDatePicker = styled(_AppDatePicker)`
    & {
        position: relative;

        display: flex;
        flex-direction: column;
        border-radius: 6px;

        font-size: 14px;
        width: 100%;
        background-color: transparent;

        overflow: hidden;

        ${(props) =>
            props.disabled &&
            css`
                cursor: not-allowed;
            `}

        .tm4-input {
            flex: 1;
            z-index: 2;
            border: 1px solid ${(props) => props.theme.colors.grayBorder};
            border-radius: 6px;
            padding: 0 10px 0 10px;
            min-height: 48px;
            height: 48px;
            max-height: 48px;
            background-color: transparent;
            font-size: 14px;
            box-shadow: none !important;

            .ant-picker-input input {
                color: ${(props) => props.theme.colors.dark400};
            }

            :focus,
            :valid {
                padding-top: 8px;
            }
        }

        .input-label {
            display: block;
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 10px;
            color: ${({ theme }) => theme?.colors?.dark};
        }

        &.invalid {
            .auth-input {
                border: 2px solid ${({ theme }) => theme?.colors?.error};
                color: ${({ theme }) => theme?.colors?.error};
            }
            small {
                display: block;
                font-weight: 700;
                margin-top: 5px;
                margin-left: 5px;
                color: ${({ theme }) => theme?.colors?.error};
            }
        }

        /* MOBILE */
        @media (max-width: 576px) {
            .validation-error-message {
                position: absolute;
                top: 101%;
                left: 10px;
                width: 100%;
                transform: unset;
                line-height: 1;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default AppDatePicker
